import { Route } from '@angular/router';
import { AppInitializationGuard } from '@evorait/pace-core';
import { MainComponent } from './components/main/main.component';
import { HomePageComponent } from './components/home-page/home-page.component';

export const appRoutes: Route[] = [
    {
        path: '',
        component: MainComponent,
        canActivate: [AppInitializationGuard],
        children: [
            {
                path: 'home',
                component: HomePageComponent,
            },
            {
                path: 'main',
                loadChildren: () => import('./forms/forms.module').then((m) => m.AuthorsFormsModule),
            },
            { path: '', redirectTo: '/home', pathMatch: 'full' },
        ],
    },
    { path: '**', redirectTo: '' },
];
